import React from 'react';
import { connect } from 'react-redux';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import { saveAs } from 'file-saver/FileSaver';
import LANGUAGES_CONTROLLER from '../../controllers/languages';

const log = new Logger('FILE_SAVE_AS', LOG_LEVELS.ERROR);

export function saveTextAs(content, mimeType, charset, filename) {
    let blob = new Blob([content], {
        type: mimeType
    });
    saveAs(blob, filename);
}

export function saveBlobAs(blob, filename) {
    saveAs(blob, filename);
}

class FileSaveAs extends React.Component {

    constructor(props) {
        super(props);
        this.onDownloadClick = this.onDownloadClick.bind(this);
    }

    onDownloadClick() {
        return (e) => {
            if(typeof this.props.fetchContent === 'function') {
                Promise.resolve(this.props.fetchContent()).then(
                    (data) => {
                        log.debug('Resolved fetchContent(): data: ', data);
                        if(this.props.isBlob) {
                            saveBlobAs(data.content, this.props.filename + "." + data.ext);
                        } else {
                            saveTextAs(data.content, this.props.mimeType, this.props.charset, this.props.filename + "." + data.ext);
                        }
                    }
                ).catch((err) => {
                    log.debug('Reject fetchContent(): error: ', err);
                    saveTextAs(err.message, this.props.mimeType, this.props.charset, this.props.filename);
                });
            } else {
                if(this.props.isBlob) {
                    saveBlobAs(this.props.content, this.props.filename);
                } else {
                    saveTextAs(this.props.content, this.props.mimeType, this.props.charset, this.props.filename);
                }
            }
            e.preventDefault();
        };
    }

    render() {
        log.debug('render() : props: ', this.props);
        const buttonClass = this.props.disabled ? "disabled secondary mb10": this.props.className;

        return (
            <button 
                className={buttonClass} 
                disabled={this.props.disabled}  
                onClick={this.onDownloadClick()}  
                download={this.props.filename}
                excludeFromReadonly={this.props.excludeFromReadonly}
            >
                {   
                    this.props.downloadLabelKey ? 
                    (
                        LANGUAGES_CONTROLLER.format(this.props.languages, this.props.downloadLabelKey)
                    ) :
                    (this.props.downloadLabel ? 
                        this.props.downloadLabel : 
                        LANGUAGES_CONTROLLER.format(this.props.languages,'xmlDataViewer_DownloadButton'))
                } 
            </button>
        );
    }

}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    log.debug('mapStateToProps: ', state);
    return {
        languages: state.languages
    };
}


FileSaveAs.defaultProps = {
    content: "",
    charset: "utf-8",
    mimeType: "text/plain",
    filename: "download.txt",
    isBlob: false,
    disabled: false,
    className:"secondary mb10"
}

export default connect(mapStateToProps)(FileSaveAs);